import { useTranslation } from "react-i18next";
import AuthPageShell from "../components/AuthPageShell";
import ForgotPasswordForm from "../components/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  const { t } = useTranslation("auth");

  return (
    <AuthPageShell
      title={t("forgotPassword.title")}
      subtitle={t("forgotPassword.subtitle")}
    >
      <ForgotPasswordForm />
    </AuthPageShell>
  );
};

export default ForgotPasswordPage;
